export default __webpack_public_path__ + "static/media/download.7de2baa3.svg";